import { Theme } from '@radix-ui/themes'
import type { ReactNode } from 'react'

type Props = { children?: ReactNode }

export const ThemeColor = 'blue' as const

export const ThemeProvider = ({ children }: Props) => {
  return (
    <Theme accentColor={ThemeColor} radius="medium" style={{ minHeight: 'auto' }}>
      {children}
    </Theme>
  )
}
